export default "./src/client/components/auth/login/open-web/spid-button/img/spid-idp-timid.svg?20c598ae2d8595205085f071016550c1";